import { motion, AnimatePresence } from "framer-motion";
import StateCard from "../sharedUi/stateCard";
import { FaAdversal } from "react-icons/fa";
import DoneAllIcon from '@mui/icons-material/DoneAll';
import FiberNewIcon from '@mui/icons-material/FiberNew';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';

export default function AdCardsUi ({value}) {

    return(<>
        <div>
            <AnimatePresence>  
                <motion.div
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: "auto" }}
                    exit={{ opacity: 0, height: 0 }}
                    transition={{ duration: 0.4, ease: "easeInOut" }}
                    className="grid grid-cols-1 sm:grid-cols-4 gap-6 pb-6 pt-7  overflow-hidden"
                >
                {[ 
                    {
                    title: "New Ads",
                    value: value?.new_ads?.current_total,
                    percentage: value?.new_ads?.percentage_change,
                    direction: value?.new_ads?.direction,
                    subtitle: "Last Month Analytics",
                    icon: <FiberNewIcon className="text-white" fontSize='medium' />,
                    mui: true,
                    iconBg: "bg-green-700"
                    },
                    {
                    title: "No. Active Ads",
                    value: value?.count_active_ads,
                    subtitle: "Last Month Analytics",
                    icon: <DoneAllIcon className="text-white" fontSize='medium' />,
                    mui: true,
                    iconBg: "bg-green-700"
                    },
                    {
                    title: "No. Ads",
                    value: value?.count_ads,
                    subtitle: "Last Month Analytics",
                    icon: <FaAdversal className="text-white" size={18} />,
                    iconBg: "bg-green-700"
                    },
                    {
                    title: "Average ad duration",
                    value: value?.average_duration_ads,
                    subtitle: "Last Month Analytics",
                    icon: <TrendingUpIcon className="text-white" fontSize='medium' />,
                    iconBg: "bg-blue-600",
                    mui: true   
                    },
                ].map((card, idx) => (
                    <motion.div
                    key={idx}
                    initial={{ rotateY: 90, opacity: 0 }}
                    animate={{ rotateY: 0, opacity: 1 }}
                    exit={{ rotateY: 90, opacity: 0 }}
                    transition={{ duration: 0.6, ease: "easeInOut", delay: idx * 0.1 }}
                    className="w-full"
                    style={{ transformStyle: "preserve-3d" }}
                    >
                    <StateCard {...card} />
                    </motion.div>
                ))}
                </motion.div>
            </AnimatePresence>
        </div>
    </>);
};